var React = require('react');

function Fire (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"fire","clipPath":"url(#clip0_2349_22685)","key":0},React.createElement("path",{"id":"Vector","d":"M23.4406 20.1284H0.555383C0.35593 20.1284 0.170137 20.0219 0.0717767 19.847C-0.026584 19.6721 -0.0238517 19.459 0.0799734 19.2869L11.5199 0.270492C11.621 0.103825 11.8013 0 11.9953 0C12.1893 0 12.3723 0.101093 12.4707 0.270492L23.9133 19.2842C24.0171 19.4563 24.0199 19.6694 23.9215 19.8443C23.8231 20.0191 23.6374 20.1257 23.4379 20.1257L23.4406 20.1284ZM1.53899 19.0137H22.457L11.998 1.63388L1.53899 19.0137Z","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2349_22685"},React.createElement("rect",{"width":"24","height":"20.1284","fill":"white"})))]);
}

Fire.defaultProps = {"width":"24","height":"21","viewBox":"0 0 24 21","fill":"none"};

module.exports = Fire;

Fire.default = Fire;
